var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavFav = function SvgNavFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_fav_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_fav_svg__st0{fill:none;stroke:#000;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nav_fav_svg__st0",
    d: "M24.1 19.6c1.4-2.4 3.6-3.9 5.8-3.6 1.9.3 3.5 1.8 4 3 1.5 3.5-2.4 9.4-9.8 14.7M24.1 19.6c-1.4-2.4-3.6-3.9-5.8-3.6-1.9.3-3.5 1.8-4 3-1.5 3.5 2.4 9.4 9.8 14.7"
  })));
};
export default SvgNavFav;